export default __webpack_public_path__ + "static/media/bitcoin_icon.055b6294.svg";